module.exports = __webpack_public_path__ + "img/file.96308a57.svg";